<template>

  <div class="sw_app">
    <div class="logo_div">
      <img src="../assets/logo.svg" >
    </div>
    <ul class="common_nav">
      <li :class="{nav_li:num == 1}" @click="jumpPage('apply')" @mouseover="swAutoPlay('stop',1)" @mouseout="swAutoPlay('start')">数据申请</li>
      <li :class="{nav_li:num == 2}" @click="routerGo('/404')"  @mouseover="swAutoPlay('stop',2)" @mouseout="swAutoPlay('start')">数据提交</li>
      <li :class="{nav_li:num == 3}" @click="routerGo('/404')" @mouseover="swAutoPlay('stop',3)" @mouseout="swAutoPlay('start')">数据备份</li>
      <!--<li :class="{nav_li:num == 4}" @click="routerGo('/404')" @mouseover="swAutoPlay('stop',4)" @mouseout="swAutoPlay('start')">订单仓储</li>-->
      <li :class="{nav_li:num == 4}" @click="routerGo('/404')" @mouseover="swAutoPlay('stop',4)" @mouseout="swAutoPlay('start')">产品线管理</li>
    </ul>
    <swiper :options="swiperOption" ref="mySwiper" style="height: 100%">
      <!-- slides -->
      <swiper-slide>
        <!--数据申请-->
        <div class="main">
          <div class="main_div clear_fix">
            <div class="left_msg first">
              <p style="margin-top: 19.94vh;font-size: 3.125vw;font-family: 微软雅黑;letter-spacing: 8px;">数据申请</p>
              <p style="margin-top: 3.82vh; font-size: 1.979vw">DATA APPLICATION</p>
              <span style="width: 3.02vw;height: 4px;background-color: white;display: inline-block;margin-top: 20.53vh"></span>
              <p style="margin-top: 3.388vh;font-size: 1.145vw;">数据申请与管理系统</p>
              <p style="margin-top: 3.49vh; font-size: 0.937vw">数据业务的申请、审批</p>
            </div>
            <div class="main_img first">
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <!--数据提交-->

        <div class="main">
          <div class="main_div clear_fix">
            <div :class="{left_msg:true,bottom0:num == 2}">
              <p style="margin-top: 19.94vh;font-size: 3.125vw;font-family: 微软雅黑;letter-spacing: 8px;">数据提交</p>
              <p style="margin-top: 3.82vh; font-size: 1.979vw">DATA SUBMITTED</p>
              <span style="width: 3.02vw;height: 4px;background-color: white;display: inline-block;margin-top: 20.53vh"></span>
              <p style="margin-top: 3.388vh;font-size: 1.145vw;">数据提交系统</p>
              <p style="margin-top: 3.49vh; font-size: 0.937vw">数据上传、下载</p>
            </div>
            <div :class="{submit_img:true,bottom0:num == 2}">
            </div>
          </div>
        </div>
      </swiper-slide>

      <swiper-slide>
        <!--数据备份-->

        <div class="main">
          <div class="main_div clear_fix">
            <div :class="{left_msg:true,bottom0:num == 3}">
              <p style="margin-top: 19.94vh;font-size: 3.125vw;font-family: 微软雅黑;letter-spacing: 8px;">数据备份</p>
              <p style="margin-top: 3.82vh; font-size: 1.979vw">DATA BACKUP</p>
              <span style="width: 3.02vw;height: 4px;background-color: white;display: inline-block;margin-top: 20.53vh"></span>
              <p style="margin-top: 3.388vh;font-size: 1.145vw;">数据备份系统</p>
              <p style="margin-top: 3.49vh; font-size: 0.937vw">数据存档、备份</p>
            </div>
            <div :class="{backup_img:true,bottom0:num == 3}">
            </div>
          </div>
        </div>
      </swiper-slide>
      <!--<swiper-slide>
        &lt;!&ndash;订单仓储&ndash;&gt;

        <div class="main">

          <div class="main_div clear_fix">
            <div :class="{left_msg:true,bottom0:num == 4}">
              <p style="margin-top: 19.94vh;font-size: 3.125vw;font-family: 微软雅黑;letter-spacing: 8px;">订单仓储</p>
              <p style="margin-top: 3.82vh; font-size: 1.979vw">ORDER & WAREHOUSING</p>
              <span style="width: 3.02vw;height: 4px;background-color: white;display: inline-block;margin-top: 20.53vh"></span>
              <p style="margin-top: 3.388vh;font-size: 1.145vw;">订单仓储系统</p>
              <p style="margin-top: 3.49vh; font-size: 0.937vw">订单的接收下发及仓储发货管理</p>
            </div>
            <div :class="{storge_img:true,bottom0:num == 4}">
            </div>
          </div>
        </div>
      </swiper-slide>-->

      <swiper-slide>
        <!--产品线管理-->
        <div class="main">
          <div class="main_div clear_fix">
            <div :class="{left_msg:true,bottom0:num == 4}">
              <p style="margin-top: 19.94vh;font-size: 3.125vw;font-family: 微软雅黑;letter-spacing: 8px;">产品线管理</p>
              <p style="margin-top: 3.82vh; font-size: 1.979vw">PRODUCT LINE MANAGEMENT</p>
              <span style="width: 3.02vw;height: 4px;background-color: white;display: inline-block;margin-top: 20.53vh"></span>
              <p style="margin-top: 3.388vh;font-size: 1.145vw;">数据产品线管理系统</p>
              <p style="margin-top: 3.49vh; font-size: 0.937vw">产品管理、产品统计展示</p>
            </div>
            <div :class="{product_img:true,bottom0:num == 4}">
            </div>
          </div>
        </div>
      </swiper-slide>

      <!-- Optional controls -->
      <div class="swiper-pagination"  slot="pagination"></div>
      <div class="swiper-scrollbar"   slot="scrollbar"></div>
    </swiper>
    <div class="footer_nav">
      <ul class="footer_ul">
        <li :class="{active:num == 1}"></li>
        <li :class="{active:num == 2}"></li>
        <li :class="{active:num == 3}"></li>
        <!--<li :class="{active:num == 4}"></li>-->
        <li :class="{active:num == 4}"></li>
      </ul>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
let _this = null
export default {
  name: 'carrousel',
  data () {
    return {
      swiperOption: {
        notNextTick: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        loop: true,
        allowTouchMove: false,
        speed: 1,
        grabCursor: false,
        setWrapperSize: true,
        pagination: '.swiper-pagination',
        paginationClickable: true,

        mousewheelControl: true,
        observeParents: true,
        /* on: {
          touchEnd: function (event) {
            if (this.activeIndex === 0) {
              _this.num = 5
            } else if (this.activeIndex === 6) {
              _this.num = 1
            } else {
              _this.num = this.activeIndex
            }
          },
          slideChangeTransitionEnd: function (event) {
            let divMsg = document.querySelectorAll('.first')
            let divImg = document.querySelectorAll('.first')
            if (this.activeIndex === 6 || this.activeIndex === 1) {
              _this.num = 1
              for (let i = 0; i < divMsg.length; i++) {
                if (!divMsg[i].classList.contains('bottom0')) {
                  divMsg[i].classList.add('bottom0')
                }
              }
              for (let i = 0; i < divImg.length; i++) {
                if (!divImg[i].classList.contains('bottom0')) {
                  divImg[i].classList.add('bottom0')
                }
              }
            } else {
              for (let i = 0; i < divMsg.length; i++) {
                if (divMsg[i].classList.contains('bottom0')) {
                  divMsg[i].classList.remove('bottom0')
                }
              }
              for (let i = 0; i < divImg.length; i++) {
                if (divImg[i].classList.contains('bottom0')) {
                  divImg[i].classList.remove('bottom0')
                }
              }
              _this.num = this.activeIndex
            }
          }
        } */

        on: {
          touchEnd: function (event) {
            if (this.activeIndex === 0) {
              _this.num = 4
            } else if (this.activeIndex === 5) {
              _this.num = 1
            } else {
              _this.num = this.activeIndex
            }
          },
          slideChangeTransitionEnd: function (event) {
            let divMsg = document.querySelectorAll('.first')
            let divImg = document.querySelectorAll('.first')
            if (this.activeIndex === 5 || this.activeIndex === 1) {
              _this.num = 1
              for (let i = 0; i < divMsg.length; i++) {
                if (!divMsg[i].classList.contains('bottom0')) {
                  divMsg[i].classList.add('bottom0')
                }
              }
              for (let i = 0; i < divImg.length; i++) {
                if (!divImg[i].classList.contains('bottom0')) {
                  divImg[i].classList.add('bottom0')
                }
              }
            } else {
              for (let i = 0; i < divMsg.length; i++) {
                if (divMsg[i].classList.contains('bottom0')) {
                  divMsg[i].classList.remove('bottom0')
                }
              }
              for (let i = 0; i < divImg.length; i++) {
                if (divImg[i].classList.contains('bottom0')) {
                  divImg[i].classList.remove('bottom0')
                }
              }
              _this.num = this.activeIndex
            }
          }
        }
      },
      num: 0
    }
  },
  methods: {
    goto (num) {
      this.swiper.slideTo(num)
      this.num = num
    },
    swAutoPlay (status, num = null) {
      if (status === 'start') {
        this.swiper.autoplay.start()
      } else if (status === 'stop' && num) {
        this.swiper.autoplay.stop()
        this.goto(num)
      }
    },
    jumpPage (url) {
      window.open(url)
    },
    routerGo (url) {
      this.$router.push(url)
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  created () {
    _this = this
  }
}
</script>
<style>
  .footer_nav{
    overflow: hidden;
    position: absolute;
    bottom: 3.08vh;
    right: 0px;
    z-index: 100;
  }
  .footer_ul{
    float: right;
  }
  .footer_ul>.active{
    background-color: #0088f0;
  }
  .footer_ul li{
    width: 0.93vw;
    height: 2px;
    margin-left: 5px;
    background-color: #303131;
    float: left;
  }
  .app,.sw_app{
    height: 100%;
    position: relative;

  }

  .nav_li{
    color:#0088f0 ;
  }
  .common_nav{
    position: absolute;
    right:7.03vw;
    margin-top: 9.03vh;
    margin-right: 0;
    padding: 0;
    z-index: 100;
  }
  .nav_li::before{
    content: "";
    position: absolute;
    bottom: -8px;
    width: 100%;
    height:2px;
    background-color: #0088f0;
  }
  ul{
    float: right;
    margin-right: 7.03vw;
    margin-top: 9.03vh;
  }
  li{
    list-style: none;
    float: left;
    font-size: 0.833vw;
    margin-left:2.343vw;
    position: relative;
    cursor: pointer;
  }

  p{
    margin: 0;
    padding: 0;
  }

  .left_msg{
    margin-left: 6.77vw;
    float: left;
    position: absolute;
    bottom: -100px;
    opacity: 0;
  }
  .main_img{
    float: right;
    margin-top: 9.75vh;
    /* margin-right: 7.7vw; */
    width: 54.552vw;
    height: 68.598vh;
    background-image: url("../assets/banner.png");
    background-size: 100%;
    background-repeat: no-repeat;
    position: absolute;
    right: 7.7vw;
    bottom: -100px;
    opacity: 0;
  }
  .bottom0{
    bottom:0px!important;
    opacity: 1!important;
    transition: all .7s ease-out ;
  }
  .backup_img{
    float: right;
    margin-top: 9.75vh;
    /*margin-right: 7.7vw;*/
    width: 54.552vw;
    height: 68.598vh;
    background-image: url("../assets/backup.png");
    background-size: 100%;
    background-repeat: no-repeat;
    position: absolute;
    right: 7.7vw;
    bottom: -100px;
    opacity: 0;
  }
  .product_img{
    float: right;
    margin-top: 9.75vh;
    /*margin-right: 7.7vw;*/
    width: 54.552vw;
    height: 68.598vh;
    background-image: url("../assets/productLine.png");
    background-size: 100%;
    background-repeat: no-repeat;
    position: absolute;
    right: 7.7vw;
    bottom: -100px;
    opacity: 0;
  }
  .submit_img{
    float: right;
    margin-top: 9.75vh;
    /*margin-right: 7.7vw;*/
    width: 54.552vw;
    height: 68.598vh;
    background-image: url("../assets/datasubmit.png");
    background-size: 100%;
    background-repeat: no-repeat;
    position: absolute;
    right: 7.7vw;
    bottom: -100px;
    opacity: 0;
  }
  .storge_img{
    float: right;
    margin-top: 9.75vh;
    /*margin-right: 7.7vw;*/
    width: 54.552vw;
    height: 68.598vh;
    background-image: url("../assets/storge.png");
    background-size: 100%;
    background-repeat: no-repeat;
    position: absolute;
    right: 2.7vw;
    bottom: -100px;
    opacity: 0;
  }

  .logo_div{
    width: 21.04vw;
    height: 10.47vh;
    margin-left: 6.77vw;
    margin-top: 5.13vh;
    position: absolute;
    z-index: 100;
  }
  .logo_div>img{
    width: 100%;
    height: 100%;
  }

  .main{
    background-color: #222;
    height: 100%;
    overflow: hidden;
  }

  .storge_main{
    height: 100%;
    background-color: #222;
  }
  .main_div{
    position: relative;
    margin-top: 15.6vh;
    height: 73.511vh;
    /* overflow: hidden; */
  }
  .clear_fix::after{
    content: "";
    clear: both;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/swipers.vue